export var CardBrandEnum;
(function (CardBrandEnum) {
    CardBrandEnum["MASTERCARD"] = "MASTERCARD";
    CardBrandEnum["VISA"] = "VISA";
    CardBrandEnum["NOT_RECOGNIZED"] = "NOT_RECOGNIZED";
})(CardBrandEnum || (CardBrandEnum = {}));
